<template>
  <div>
    <!-- {{$store.state.q}} -->
      <!--<template v-for="(chip, i) of selectedTopics" >-->
        <!-- {{chip}} -->
      <!--    <span class="chip" :key="i">{{chip}}-->
      <!--    <font-awesome-icon icon="times-circle" v-on:click="selectedTopics = selectedTopics.filter(x => x != chip)" />-->
              <!--<button type="button" class="chip-remove" v-on:click="selectedTopics = selectedTopics.filter(x => x != chip)"></button>-->
      <!--    </span>-->
      <!--</template>-->
      <!--<hr/>-->
      <input type="text" v-model.trim.lazy="keyword" placeholder="Search"/>
  <ul class="topictree-list">
    <!-- {{selectedTopics}} -->
    <!-- topic browse displays -->
    <template v-for="(item, index) in topics">
      <li v-if="unfolded[item]" :style="topicLevel(item)" :key="item">
          <input type="checkbox" v-model="selectedTopics" :value="item" ><span v-on:click="unFold(index, isFolded(index))" class="topic"><a>{{item}}</a> &nbsp;&nbsp;{{isFolded(index)}}</span>
        <!-- <a _v-on:click.stop.prevent="browsebycategory(item)" :href="'http://www.ikgf.uni-erlangen.de/aigaion2/index.php/topics/single/'+(index+1)" :style="'margin-left:'+ ((item.split(' ')[0].replace(/[0-9]*/g,'').length -1)/2 * 20)+'px;'" >{{item}}</a> <template v-if="items[index+1] && ((items[index+1]).split(' ')[0].replace(/[0-9]*/g,'').length >1) && (item.split(' ')[0].replace(/[0-9]*/g,'').length == 1)" ><a href='#' :data="item.split(' ')[0].split('.',2).join('_')" onClick="$('.'+ $(this).attr('data')).toggle(); $(this).text($(this).text()==='+'?'-':'+')">+</a></template> -->
        <!--<span title="read: 0 of 32 publications"><i> 0/32</i></span>-->
      </li>
    </template>
    <!-- End of topic browse displays -->
  </ul>
  </div>
</template>

<script>
  // @ is an alias to /src
  
import Vue from 'vue'

  const FOLDED_SIGN = "[-]"
  const UNFOLDED_SIGN = "[+]"
  export default {
    name: 'topics',
    data: function () {
      return {
        // topics: [],
        unfolded: {},
        keyword: ''
        // selectedTopics: []
      }
    },
    components: {
    },
    computed: {
      topics () {
        return this.$store.getters.getTopics
      },
      selectedTopics: {
        set(val) {
          this.$store.dispatch('selectedTopics', val.sort())
          this.$store.dispatch('fetchAuthors')
          this.$store.dispatch('fetchPublications')  
        },
        get() {
          return this.$store.getters.getSelectedTopics
        }
      }
    },
    watch: {
      topics: function (val) {
        this.unfolded = val.reduce((acc, x) => {
          acc[x] = x.split(' ')[0].replace(/[^.]/gm, '').length < 4
          return acc
        }, {})
      },
      keyword: function (val) {
        if (val.length > 0) {

          this.$router.push({name: 'publications', params: { keyword: val}})

          // this.search(`(all_txt_cjk:(${terms.join('')}))`)
        }
      }
      // selectedTopics: function(val) {
      //   this.$store.dispatch('selectedTopics', val)
      // }
    },
    created: async function () {
      this.$store.dispatch('fetchTopics')      
    },
    beforeMount: function() {
      // this.selectedTopics = this.$store.getters.getSelectedTopics
    },
    methods: {
      topicLevel: function (topic) {
        return `padding-left: ${topic.split(' ')[0].replace(/[^.]/gm, '').length}em`
      },
      isFolded: function(index) {
        let topic = this.topics[index]
        let topicLevel = topic.split(" ")[0].replace(/[^.]/gm, '').length
        let nextTopic = this.topics[index +1] || ""        
        let nextTopicLevel = nextTopic.split(" ")[0].replace(/[^.]/gm, '').length
        if (topic && nextTopic && (nextTopicLevel - topicLevel === 1) && topic.charAt(0) === nextTopic.charAt(0)) {
          return !this.unfolded[nextTopic] ? UNFOLDED_SIGN : FOLDED_SIGN
        }

        return ''
      },
      unFold: function(index, sign) {
        // console.log(sign)
        let topic = this.topics[index]
        // console.log(index, topic)
        let topicLevel = topic.split(" ")[0].replace(/[^.]/gm, '').length
        for (let i = index + 1; i < this.topics.length; i ++){
          let nextTopic = this.topics[i]
          if (nextTopic) {
            let nextTopicLevel = nextTopic.split(" ")[0].replace(/[^.]/gm, '').length

            if (sign === UNFOLDED_SIGN) {
              if (nextTopicLevel - topicLevel === 1) {
                Vue.set( this.unfolded, nextTopic, true )
              
              } else if (nextTopicLevel > topicLevel){
                continue
              } else {
                break
              }
            } else {
              if (nextTopicLevel > topicLevel) {
                Vue.set( this.unfolded, nextTopic, false ) 
              } else {
                break
              }
            } 
          }          
        }
      }
    }
  }
</script>
<style>
  .topictree-list {
    list-style:none !important;
    padding:0;
    margin:0;
  }
  .topic {
    padding-left: 1em !important;
  }
</style>